// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { ClipLoader } from "react-spinners";
// import "./userHome.css";

// const UserDashboard = () => {
//   const [portfolio, setPortfolio] = useState([]);
//   const [summary, setSummary] = useState(null);
//   const [error, setError] = useState("");
//   const [isLoading, setIsLoading] = useState(true);

//   useEffect(() => {
//     const fetchPortfolio = async () => {
//       const user = JSON.parse(localStorage.getItem("user"));
//       const token = localStorage.getItem("token");

//       if (!user || !token) {
//         setError("User not logged in. Please login again.");
//         setIsLoading(false);
//         return;
//       }

//       try {
//         const response = await axios.get(`/api/admin/portfolio/${user.id}`, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         });
//         setPortfolio(response.data.portfolios);
//         setSummary(response.data.summary);
//       } catch (error) {
//         setError(
//           error.response?.data?.message || "Error fetching portfolio data"
//         );
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchPortfolio();
//   }, []);

//   // const convertToINR = (value, currency) => {
//   //   if (!value) return 0;
//   //   return currency === "AED" ? (value * 23.25).toFixed(2) : value;
//   // };

//   return (
//     <div className="portfolio-container">
//       {isLoading ? (
//         <div className="loading-overlay">
//           <ClipLoader color="#00BFFF" size={150} />
//         </div>
//       ) : error ? (
//         <p className="error-message">{error}</p>
//       ) : portfolio.length > 0 ? (
//         <>
//           {portfolio.map((item) => (
//             <div className="portfolio-card" key={item._id}>
//               <div className="portfolio-inner">
//                 <div className="portfolio-logo-name">
//                   <img
//                     src={item.company?.logo || "/placeholder-logo.png"}
//                     alt={item.company?.name || "Company Logo"}
//                   />
//                   <h3>{item.company?.name || "Company Name Not Available"}</h3>
//                 </div>

//                 <div className="portfolio-current-value">
//                   <p>Invested Amount</p>
//                   <h2>{item.investedAmount} USD</h2>
//                 </div>

//                 <div className="portfolio-current-value">
//                   <p>Withdrawal</p>
//                   <h2>{item.withdrawal} USD</h2>
//                 </div>

//                 <div className="portfolio-current-value">
//                   <p>This Month PNL</p>
//                   <h2
//                     className={
//                       item.thismonthpnl >= 0
//                         ? "value-positive"
//                         : "value-negative"
//                     }
//                   >
//                     {item.thismonthpnl || 0} USD
//                   </h2>
//                 </div>

//                 <div className="portfolio-current-value">
//                   <p>Monthly PNL Percentage</p>
//                   <h2
//                     className={
//                       item.monthlyPnlPercentage >= 0
//                         ? "value-positive"
//                         : "value-negative"
//                     }
//                   >
//                     {item.monthlyPnlPercentage || 0}%
//                   </h2>
//                 </div>

//                 <div className="portfolio-current-value">
//                   <p>Current Value</p>
//                   <h2
//                     className={
//                       item.currentValue +
//                         item.withdrawal -
//                         item.investedAmount >=
//                       0
//                         ? "value-positive"
//                         : "value-negative"
//                     }
//                   >
//                     {item.currentValue} USD
//                   </h2>
//                 </div>

//                 <div className="portfolio-current-value">
//                   <p>Profit Percentage</p>
//                   <h2
//                     className={
//                       item.profitPercentage >= 0
//                         ? "value-positive"
//                         : "value-negative"
//                     }
//                   >
//                     {item.profitPercentage || 0}%
//                   </h2>
//                 </div>
//               </div>
//             </div>
//           ))}

//           {/* Summary Row */}
//           {summary && (
//             <div className="portfolio-card summary-card total-summary">
//               <div className="portfolio-inner">
//                 <div className="portfolio-logo-name">
//                   <h3>Total Summary</h3>
//                 </div>

//                 <div className="portfolio-current-value">
//                   <p>Total Invested </p>
//                   <h2>{summary.totalInvested} USD</h2>
//                 </div>

//                 <div className="portfolio-current-value">
//                   <p>Total Withdrawal</p>
//                   <h2>{summary.totalWithdrawal} USD</h2>
//                 </div>

//                 <div className="portfolio-current-value">
//                   <p>This Month total PNL</p>
//                   <h2
//                     className={
//                       summary.totalThisMonthPnl >= 0
//                         ? "value-positive"
//                         : "value-negative"
//                     }
//                   >
//                     {summary.totalThisMonthPnl} USD
//                   </h2>
//                 </div>

//                 <div className="portfolio-current-value">
//                   <p>Total Monthly PNL Percentage</p>
//                   <h2
//                     className={
//                       summary.totalMonthlyPnlPercentage >= 0
//                         ? "value-positive"
//                         : "value-negative"
//                     }
//                   >
//                     {summary.totalMonthlyPnlPercentage}%
//                   </h2>
//                 </div>

//                 <div className="portfolio-current-value">
//                   <p>Total Current Value</p>
//                   <h2
//                     className={
//                       summary.totalCurrentValue >= summary.totalInvested
//                         ? "value-positive"
//                         : "value-negative"
//                     }
//                   >
//                     {summary.totalCurrentValue} USD
//                   </h2>
//                 </div>

//                 <div className="portfolio-current-value">
//                   <p> Total Profit Percentage</p>
//                   <h2
//                     className={
//                       summary.totalProfitPercentage >= 0
//                         ? "value-positive"
//                         : "value-negative"
//                     }
//                   >
//                     {summary.totalProfitPercentage}%
//                   </h2>
//                 </div>
//               </div>
//             </div>
//           )}
//         </>
//       ) : (
//         <p className="no-data-message">No portfolio data found.</p>
//       )}
//     </div>
//   );
// };

// export default UserDashboard;
import React, { useEffect, useState } from "react";
import axios from "axios";
import { ClipLoader } from "react-spinners";
import "./userHome.css";

const UserDashboard = () => {
  const [portfolio, setPortfolio] = useState([]);
  const [summary, setSummary] = useState(null);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchPortfolio = async () => {
      const user = JSON.parse(localStorage.getItem("user"));
      const token = localStorage.getItem("token");

      if (!user || !token) {
        setError("User not logged in. Please login again.");
        setIsLoading(false);
        return;
      }

      try {
        const response = await axios.get(`/api/admin/portfolio/${user.id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setPortfolio(response.data.portfolios);
        setSummary(response.data.summary);
      } catch (error) {
        setError(
          error.response?.data?.message || "Error fetching portfolio data"
        );
      } finally {
        setIsLoading(false);
      }
    };

    fetchPortfolio();
  }, []);

  // Function to format date for display (dd-mm-yyyy)
  const formatDateForDisplay = (dateString) => {
    if (!dateString) return "N/A";

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "N/A";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day} - ${month} - ${year}`;
  };

  return (
    <div className="portfolio-container">
      {isLoading ? (
        <div className="loading-overlay">
          <ClipLoader color="#00BFFF" size={150} />
        </div>
      ) : error ? (
        <p className="error-message">{error}</p>
      ) : portfolio.length > 0 ? (
        <>
          {portfolio.map((item) => (
            <div className="portfolio-card" key={item._id}>
              <div className="portfolio-inner">
                <div className="portfolio-logo-name">
                  <img
                    src={item.company?.logo || "/placeholder-logo.png"}
                    alt={item.company?.name || "Company Logo"}
                  />
                  <h3>{item.company?.name || "Company Name Not Available"}</h3>
                </div>

                <div className="portfolio-current-value">
                  <p>Invested Amount</p>
                  <h2>
                    {item.investedAmount} {item.currencyCode}
                  </h2>
                </div>

                <div className="portfolio-current-value">
                  <p>Withdrawal</p>
                  <h2>
                    {item.withdrawal} {item.currencyCode}
                  </h2>
                </div>

                <div className="portfolio-current-value">
                  <p>This Month PNL</p>
                  <h2
                    className={
                      item.thismonthpnl >= 0
                        ? "value-positive"
                        : "value-negative"
                    }
                  >
                    {item.thismonthpnl || 0} {item.currencyCode}
                  </h2>
                </div>

                <div className="portfolio-current-value">
                  <p>Monthly PNL Percentage</p>
                  <h2
                    className={
                      item.monthlyPnlPercentage >= 0
                        ? "value-positive"
                        : "value-negative"
                    }
                  >
                    {item.monthlyPnlPercentage || 0}%
                  </h2>
                </div>

                <div className="portfolio-current-value">
                  <p>Current Value</p>
                  <h2
                    className={
                      item.currentValue +
                        item.withdrawal -
                        item.investedAmount >=
                      0
                        ? "value-positive"
                        : "value-negative"
                    }
                  >
                    {item.currentValue} {item.currencyCode}
                  </h2>
                </div>

                <div className="portfolio-current-value">
                  <p>Profit Percentage</p>
                  <h2
                    className={
                      item.profitPercentage >= 0
                        ? "value-positive"
                        : "value-negative"
                    }
                  >
                    {item.profitPercentage || 0}%
                  </h2>
                </div>

                {/* New Last Updated Column */}
                {/* <div className="portfolio-current-value">
                  <p>Last Updated</p>
                  <h2 className="value-neutral">
                    {formatDateForDisplay(item.updatedDate)}
                  </h2>
                </div> */}

                <div className="portfolio-current-value">
                  <p>Last Updated</p>
                  <h2 className="value-neutral date-text">
                    {formatDateForDisplay(item.updatedDate)}
                  </h2>
                </div>
              </div>
            </div>
          ))}

          {/* Summary Row - Without Last Updated */}
          {summary && (
            <div className="portfolio-card summary-card total-summary">
              <div className="portfolio-inner summary-inner">
                <div className="portfolio-logo-name">
                  <h3>Total Summary</h3>
                </div>

                <div className="portfolio-current-value">
                  <p>Total Invested </p>
                  <h2>
                    {summary.totalInvested} {summary.summaryCurrency}
                  </h2>
                </div>

                <div className="portfolio-current-value">
                  <p>Total Withdrawal</p>
                  <h2>
                    {summary.totalWithdrawal} {summary.summaryCurrency}
                  </h2>
                </div>

                <div className="portfolio-current-value">
                  <p>This Month total PNL</p>
                  <h2
                    className={
                      summary.totalThisMonthPnl >= 0
                        ? "value-positive"
                        : "value-negative"
                    }
                  >
                    {summary.totalThisMonthPnl} {summary.summaryCurrency}
                  </h2>
                </div>

                <div className="portfolio-current-value">
                  <p>Total Monthly PNL Percentage</p>
                  <h2
                    className={
                      summary.totalMonthlyPnlPercentage >= 0
                        ? "value-positive"
                        : "value-negative"
                    }
                  >
                    {summary.totalMonthlyPnlPercentage}%
                  </h2>
                </div>

                <div className="portfolio-current-value">
                  <p>Total Current Value</p>
                  <h2
                    className={
                      summary.totalCurrentValue >= summary.totalInvested
                        ? "value-positive"
                        : "value-negative"
                    }
                  >
                    {summary.totalCurrentValue} {summary.summaryCurrency}
                  </h2>
                </div>

                <div className="portfolio-current-value">
                  <p> Total Profit Percentage</p>
                  <h2
                    className={
                      summary.totalProfitPercentage >= 0
                        ? "value-positive"
                        : "value-negative"
                    }
                  >
                    {summary.totalProfitPercentage}%
                  </h2>
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <p className="no-data-message">No portfolio data found.</p>
      )}
    </div>
  );
};

export default UserDashboard;
